import React from 'react'

import { createSvgIcon } from './utils/create-svg-icon'

export const MenuIcon = createSvgIcon(
  <>
    <title>menu</title>
    <g
      className="nc-icon-wrapper"
      fill="#222222"
      stroke="#222222"
      strokeLinecap="square"
      strokeLinejoin="miter"
      strokeWidth="1"
      transform="translate(0.5 0.5)"
    >
      <line
        data-color="color-2"
        fill="none"
        strokeMiterlimit="10"
        x1="2"
        x2="30"
        y1="16"
        y2="16"
      />{' '}
      <line
        fill="none"
        stroke="#222222"
        strokeMiterlimit="10"
        x1="2"
        x2="30"
        y1="7"
        y2="7"
      />{' '}
      <line
        fill="none"
        stroke="#222222"
        strokeMiterlimit="10"
        x1="2"
        x2="30"
        y1="25"
        y2="25"
      />
    </g>
  </>
)
